"use client"

import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"

import { cn } from "../../../utils/cn"
import { CheckIcon } from "lucide-react";

interface CheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  error?: boolean;
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, error, ...props }, ref) => {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "Checkbox tw-peer tw-h-4 tw-w-4 tw-shrink-0 tw-border tw-border-black tw-shadow-sm",
        className,
        error && "tw-border-red-500"
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("tw-flex tw-items-center tw-justify-center")}
        style={{
          maxHeight: "16px",
        }}
      >
        <CheckIcon className="tw-max-h-fit" color="#000000" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }